import { Logger } from './types';

let loggerRef: Logger | null = null;

export const setLoggerRef = (logger: Logger): void => {
  loggerRef = logger;
};

export const getLoggerRef = (): Logger | null => loggerRef;
